module.exports = __webpack_public_path__ + "static/member02-535acb30a052032e1c409446be74ce0e.jpg";